import { apiRequest, handleCall } from 'syft-acp-core/api/call'
import { CreateAgencyPlatformInput } from './types'

export const createAgencyPlatform = ({ payload: reqArgs }: CreateAgencyPlatformInput) =>
  new Promise((resolve, reject) => {
    const req = apiRequest({ path: '/admin/agency_platforms', reqArgs, method: 'POST' })
    handleCall(req, resolve, reject, true)
  })
